import { compose, withProps } from 'recompose';

import withCost from './withCost';
import OrderInformation from '../components/OrderInformation';
import sharedContainer from './OrderInformationSharedContainer';

export default compose(
  withCost,
  sharedContainer,
  withProps(props => ({
    // sending 'kioskMode' here from outside payment modal,
    // since kiosk context (and hence kiosk prop) gets lost inside Modal
    shouldShowTip: !props.bookNoPayQuery && props.activeTip && !props.kioskMode,
    headingClassName: 'c-payment-modal-heading u-mb',
    className: 'c-payment-modal-order-info',
  })),
)(OrderInformation);



// WEBPACK FOOTER //
// ./src/app/reservation/containers/PaymentModalOrderInformation.js